<template>
  <v-tooltip top :disabled="!tooltip">
    <template #activator="{ attrs, on }">
      <v-btn
        v-bind="attrs"
        :href="url"
        :loading="isLoading"
        outlined
        depressed
        block
        :color="settings.color"
        :download="filename"
        v-on="on"
        @click="$emit('click', toggleLoading)"
      >
        <v-icon
          v-if="settings.icon"
          style="margin-right: 8px;"
          v-text="settings.icon"
        />
        <span>{{ settings.label }}</span>
      </v-btn>
    </template>
    <div v-text="tooltip" />
  </v-tooltip>
</template>

<script>
import { getReportStatusSettings } from '@/typings/api/Report'


export default {
  name: 'LKButtonReport',
  props: {
    status: {
      type: String,
      required: true,
    },
    url: String,
    filename: String,
    tooltip: String,
  },
  data: () => ({
    isLoading: false,
  }),
  computed: {
    settings() {
      return getReportStatusSettings(this.status)
    },
  },
  methods: {
    toggleLoading() {
      this.isLoading = !this.isLoading
      return this.toggleLoading
    },
  },
}
</script>
